var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-banner"},[_c('el-carousel',{attrs:{"height":"474px","interval":5000}},_vm._l((_vm.list),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"img",attrs:{"src":item.swiperimageurl,"alt":""},on:{"click":function($event){return _vm.itemPath(item.jumpurl)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }